import { createSignal } from "solid-js";

export type Locale = "ru" | "en";

const dictionaries = {
  ru: {
    APP_NAME: "Alex Tracker",
    WELCOME_MESSAGE: "Учёт и планирование тренировок",
    LOGIN_VIA_TELEGRAM: "Войти через Telegram",
    LOGIN_HINT: "Откройте приложение в Telegram или войдите через виджет",
    LOADING: "Загрузка…",
    PROFILE: "Профиль",
    CALENDAR: "Календарь",
    WORKOUTS: "Тренировки",
    TEMPLATES: "Шаблоны",
    STATS: "Статистика",
    STREAK: "Стрик",
    WEEKS: "нед.",
    WEEKLY_GOAL: "Недельная цель",
    SET_GOAL: "Поставить цель",
    TARGET_WORKOUTS: "Тренировок в неделю",
    TARGET_MINUTES: "Минут в неделю",
    WEEKLY_MINUTES: "Минут за неделю",
    MINUTES_UNTIMED_NOT_COUNTED: "Тренировки без времени не считаются",
    GOAL_MINUTES_RANGE: "От 1 до 6000 мин",
    GOAL_COUNT_RANGE: "От 1 до 14",
    GOAL_NEED_ONE: "Нужна хотя бы одна цель",
    PROGRESS: "Прогресс",
    SAVE: "Сохранить",
    CANCEL: "Отмена",
    DELETE: "Удалить",
    EDIT: "Изменить",
    CREATE: "Создать",
    ADD_EXERCISE: "Добавить упражнение",
    EXERCISE: "Упражнение",
    EXERCISES: "Упражнения",
    SETS: "Подходы",
    REPS: "Повторы",
    WEIGHT: "Вес",
    KG: "кг",
    NOTES: "Заметки",
    TITLE: "Название",
    DATE: "Дата",
    COMPLETED: "Выполненные",
    PLANNED: "План",
    MISSED: "Пропущена",
    MISSED_HINT:
      "День прошёл, но тренировку всё ещё можно отметить выполненной — без давления.",
    START_TIME: "Время начала",
    START_TIME_HINT:
      "Необязательно. Если указать — напомним заранее. Без времени — утром в день тренировки.",
    REMINDER_LEAD: "Напоминание до начала",
    REMINDER_LEAD_HINT:
      "Для планов со временем. Без времени — утреннее напоминание, как раньше.",
    REMINDER_LEAD_1H: "1 час",
    REMINDER_LEAD_2H: "2 часа",
    LOG_WORKOUT: "Записать тренировку",
    PLAN_WORKOUT: "Запланировать",
    MARK_DONE: "Отметить выполненной",
    APPLY_TEMPLATE: "Применить шаблон",
    NO_TEMPLATES: "Шаблонов пока нет",
    CREATE_TEMPLATE: "Создать шаблон",
    PREVIOUS_RESULTS: "Предыдущие результаты",
    NO_HISTORY: "Нет предыдущих результатов",
    LAST_TIME: "В прошлый раз: {v}",
    RECORDS: "Рекорды",
    NEW_RECORD: "Новый рекорд",
    REC_MAX_WEIGHT: "макс. вес",
    REC_EST_1RM: "расч. 1ПМ",
    REC_MAX_DURATION: "макс. время",
    REC_MAX_DISTANCE: "макс. дистанция",
    MONTH_WORKOUTS: "Тренировок за месяц",
    TOTAL_TONNAGE: "Тоннаж за месяц",
    TOP_EXERCISES: "Топ упражнений",
    NO_DATA: "Пока нет данных",
    LANGUAGE: "Язык",
    LOGOUT: "Выйти",
    TODAY: "Сегодня",
    MON: "Пн",
    TUE: "Вт",
    WED: "Ср",
    THU: "Чт",
    FRI: "Пт",
    SAT: "Сб",
    SUN: "Вс",
    ERROR_GENERIC: "Что-то пошло не так",
    AUTH_FAILED: "Не удалось войти",
    CONFIRM_DELETE: "Удалить?",
    EMPTY_DAY: "Нет тренировок в этот день",
    NEW_COMPLETED: "Новая тренировка",
    NEW_PLANNED: "Новый план",
    FROM_TEMPLATE: "Из шаблона",
    OF: "из",
    DONE: "Готово",
    BACK: "Назад",
    NAME: "Имя",
    USERNAME: "Юзернейм",
    OPTIONAL: "необяз.",
    CATALOG: "Каталог",
    MUSCLE_GROUPS: "Группы мышц",
    FILTER_ALL: "Все",
    SEARCH: "Поиск",
    FROM_CATALOG: "Из каталога",
    NO_CATALOG_EXERCISES: "В каталоге пока нет упражнений",
    ADD_TO_CATALOG: "Добавить в каталог",
    NEW_EXERCISE: "Новое упражнение",
    EDIT_EXERCISE: "Изменить упражнение",
    PICK_EXERCISE: "Выбрать упражнение",
    MG_CHEST: "Грудь",
    MG_BACK: "Спина",
    MG_SHOULDERS: "Плечи",
    MG_BICEPS: "Бицепс",
    MG_TRICEPS: "Трицепс",
    MG_LEGS: "Ноги",
    MG_GLUTES: "Ягодицы",
    MG_CORE: "Кор",
    MG_CARDIO: "Кардио",
    MG_FULL_BODY: "Всё тело",
    MG_OTHER: "Другое",
    DURATION: "Длительность",
    DURATION_MIN: "мин",
    TOTAL_DURATION: "Время за месяц",
    AVG_DURATION: "Средняя тренировка",
    START_WORKOUT_TIMER: "Начать тренировку",
    STOP_WORKOUT_TIMER: "Завершить тренировку",
    TIMER_RUNNING: "Идёт тренировка",
    CLEAR: "Очистить",
    REPEAT: "Повторить",
    REPEAT_LAST: "Повторить последнюю",
    REPEAT_LAST_WEEK: "Неделя → план",
    REPEAT_WORKOUT: "Повтор тренировки",
    REPEAT_FROM: "На основе",
    REPEAT_HINT: "Отредактируйте и сохраните — дата, заметки и длительность не копируются",
    REPEAT_CHOOSE: "Как повторить эту тренировку?",
    REPEAT_AS_COMPLETED: "Как выполненную",
    REPEAT_AS_PLANNED: "Как план",
    SAVE_AS_COMPLETED: "Выполненная",
    SAVE_AS_PLANNED: "План",
    COPY_NOTES: "Скопировать заметки",
    COPY_EXERCISE_NOTES_HINT: "включая заметки к упражнениям",
    NO_WORKOUT_TO_REPEAT: "Нет выполненных тренировок для повтора",
    NO_LAST_WEEK_WORKOUTS: "За прошлую неделю нет выполненных тренировок",
    CONFIRM_REPEAT_LAST_WEEK:
      "Создать {n} план(ов) на эту неделю по тренировкам прошлой?",
    EXERCISE_NOTES_PLACEHOLDER: "Заметка к упражнению (необязательно)",
    SHOW_MORE: "ещё",
    SHOW_LESS: "свернуть",
    WORKOUT_NOT_FOUND: "Тренировка не найдена",
    WORKOUT_NOT_FOUND_HINT:
      "Возможно, она была удалена или ссылка устарела.",
    BACK_TO_WORKOUTS: "К списку тренировок",
    WORKOUTS_LIST: "Список",
    CALENDAR_LIST_HINT: "Все тренировки — в удобном списке",
    ALL_WORKOUTS: "Все тренировки",
    ALL_WORKOUTS_HINT: "Выполненные и план в одном месте",
    NO_WORKOUTS_YET: "Пока нет тренировок",
    NO_COMPLETED_WORKOUTS: "Пока нет выполненных тренировок",
    NO_PLANNED_WORKOUTS: "Пока нет запланированных",
    NO_WORKOUTS_FOR_DAY: "В этот день тренировок нет",
    WORKOUTS_EMPTY_HINT: "Запиши тренировку или составь план",
    BACK_TO_CALENDAR: "К календарю",
    CLEAR_FILTER: "Сбросить",
    DAY_WORKOUTS: "За этот день",
    VIEW_DAY_LIST: "Весь день",
    BODY_WEIGHT: "Вес",
    CURRENT_WEIGHT: "Текущий вес",
    LOG_WEIGHT: "Записать вес",
    EDIT_WEIGHT: "Изменить запись",
    WEIGHT_CHART: "Динамика",
    WEIGHT_HISTORY: "История",
    NO_WEIGHT_DATA: "Пока нет записей веса",
    VS_PREVIOUS: "к пред.",
    DELTA_7D: "7 дней",
    DELTA_30D: "30 дней",
    PERIOD_30D: "1 мес",
    PERIOD_90D: "3 мес",
    PERIOD_ALL: "Всё",
    PROGRESS_RANGE_1Y: "Год",
    PROGRESS_NEED_TWO: "Нужно хотя бы две записи",
    PROGRESS_CHART: "График прогресса",
    WEIGHT_MIN: "Мин",
    WEIGHT_MAX: "Макс",
    WEIGHT_AVG: "Сред",
    WEIGHT_INVALID: "Введите корректный вес",
    WEIGHT_NOTES_HINT: "утро / после тренировки…",
    OPEN_WEIGHT: "Открыть вес",
    ADMIN_PANEL: "Админ",
    ADMIN_HINT: "Служебная панель. Видна только администраторам.",
    ADMIN_OVERVIEW: "Обзор платформы",
    ADMIN_USERS: "Пользователи",
    ADMIN_ADMINS: "Админы",
    ADMIN_COMPLETED: "Выполненные",
    ADMIN_PLANNED: "Планы",
    ADMIN_OPEN_PLANS: "открытых",
    ADMIN_WEIGHT_LOGS: "записей",
    ADMIN_NEW_USERS_30D: "Новые за 30д",
    ADMIN_SEARCH_USERS: "Поиск: имя, @username, telegram id",
    ADMIN_FILTER_ADMINS: "Админы",
    ADMIN_FILTER_USERS: "Юзеры",
    ADMIN_LAST_WORKOUT: "Последняя тренировка",
    ADMIN_USER_DETAIL: "Пользователь",
    ADMIN_JOINED: "Регистрация",
    ADMIN_GRANT: "Сделать админом",
    ADMIN_REVOKE: "Снять админа",
    ADMIN_GRANT_CONFIRM: "Выдать права администратора?",
    ADMIN_REVOKE_CONFIRM: "Снять права администратора?",
    ADMIN_CANNOT_SELF: "Нельзя снять админку у самого себя",
    ADMIN_RECENT_COMPLETED: "Последние выполненные",
    ADMIN_RECENT_PLANNED: "Последние планы",
    CLOSE: "Закрыть",
    COMPLETE_WORKOUT_TITLE: "Тренировка выполнена?",
    COMPLETE_WORKOUT_HINT:
      "Можно указать длительность сейчас или оставить пустым и дописать позже.",
    COMPLETE_AND_OPEN: "Сохранить и открыть",
    COMPLETE_SKIP_DURATION: "Без длительности — открыть",
    CREATE_WORKOUT: "Создать тренировку",
    START_WORKOUT_NOW: "Начать сейчас",
    START_WORKOUT_NOW_HINT: "Сразу в режим выполнения",
    LOG_COMPLETED_SHORT: "Записать выполненную",
    LOG_COMPLETED_HINT: "Добавить уже завершённую",
    PLAN_WORKOUT_SHORT: "Запланировать",
    PLAN_WORKOUT_HINT: "На выбранную дату",
    FROM_TEMPLATE_SHORT: "Из шаблона",
    FROM_TEMPLATE_HINT: "На основе существующего шаблона",
    ACTIVE_WORKOUT: "Активная тренировка",
    FINISH_WORKOUT: "Завершить тренировку",
    ACTIVE_DISCARD: "Выйти",
    ACTIVE_DISCARD_CONFIRM:
      "Выйти без сохранения? Прогресс тренировки будет потерян.",
    ACTIVE_REPLACE_CONFIRM:
      "Уже есть незавершённая тренировка. Заменить её новой?",
    ACTIVE_NEED_EXERCISE: "Добавьте хотя бы одно упражнение с подходами",
    ACTIVE_SAVED: "Тренировка сохранена",
    ACTIVE_EMPTY: "Добавьте упражнение, чтобы начать",
    ACTIVE_RESUME: "Продолжить тренировку",
    EXERCISE_LIST: "Список",
    NEXT_EXERCISE: "Следующее",
    NEXT: "Далее",
    PREV: "Назад",
    GO_TO_EXERCISE: "К упражнению",
    FINISH_SHORT: "Готово",
    CIRCUIT: "Цикл",
    CIRCUIT_ROUND: "Круг {n} из {total}",
    CIRCUIT_ROUND_SHORT: "{n}/{total}",
    CIRCUIT_ROUNDS: "{n} круг.",
    CIRCUIT_ROUNDS_LABEL: "кругов",
    CIRCUIT_BANKED: "в кругах",
    CIRCUIT_IN: "В цикле",
    CIRCUIT_JOIN: "В цикл",
    CIRCUIT_LEAVE: "Убрать",
    CIRCUIT_LINK_PREV: "С предыдущим",
    CIRCUIT_GROUP_TITLE: "Цикл",
    CIRCUIT_GROUP_COUNT: "{n} упр.",
    CIRCUIT_HINT:
      "Цикл = упражнения повторяются кругами. Нажми «В цикл» или «С предыдущим».",
    CIRCUIT_BADGE: "цикл",
    TOGGLE_CIRCUIT: "В цикле / вне цикла",
    LINK_CIRCUIT: "Связать с предыдущим в цикл",
    ADD_SET: "Подход",
    SET_DONE: "Подход выполнен",
    REST_TIMER: "Отдых",
    REST_START: "Старт",
    REST_START_SHORT: "Отдых",
    REST_PAUSE: "Пауза",
    REST_RESUME: "Далее",
    REST_RESET: "Сброс",
    REST_CUSTOM: "Своё",
    REST_AGAIN: "Ещё раз",
    REST_DONE: "Отдых закончен",
    REST_PAUSED: "Пауза",
    REST_RUNNING: "Идёт",
    REST_HINT: "После подхода нажми ✓ — таймер стартанёт сам. Или выбери время ниже.",
    REST_PICK_DURATION: "Длительность отдыха",
    WORKOUT_PAUSE: "Пауза тренировки",
    WORKOUT_RESUME: "Продолжить",
    WORKOUT_PAUSED: "пауза",
    WORKOUT_PAUSED_HINT:
      "Тренировка на паузе — время не идёт. Можно править подходы, затем продолжить.",
    CATALOG_LOOKUP_HINT: "Каталог · начни вводить название",
    NEW_EXERCISE_AUTO_HINT: "Новое — попадёт в каталог само",
    UNIT: "Единица",
    UNIT_KG: "кг",
    UNIT_REPS: "повт.",
    UNIT_SECONDS: "сек",
    UNIT_MINUTES: "мин",
    DRAG_REORDER: "Перетащить упражнение",
    STREAK_UPDATED: "Стрик обновлён",
    STREAK_UPDATED_HINT: "Ещё одна неделя подряд",
    STREAK_WEEKS_COUNT: "{n} нед. подряд",
    STREAK_DELTA: "+{n}",
    STREAK_CONTINUE: "Продолжить",
    STREAK_SESSION_DONE: "Тренировка завершена",
    STREAK_FIRST: "Первая тренировка",
    STREAK_BACK: "Стрик снова идёт",
    STREAK_TIER_SPARK: "1 нед.",
    STREAK_TIER_EMBER: "3 нед.",
    STREAK_TIER_FLAME: "5 нед.",
    STREAK_TIER_INFERNO: "10 нед.",
    STREAK_TIER_MYTHIC: "15 нед.",
    STREAK_TIER_LEGEND: "20 нед.",
    STREAK_TIER_IMMORTAL: "30 нед.",
    HERO_LOGIN_KICKER: "Вход",
    HERO_LOGIN_TITLE: "Вход",
    HERO_LOGIN_LINE: "Учёт и планирование тренировок",
    HERO_CALENDAR_KICKER: "Календарь",
    HERO_CALENDAR_LINE: "Тренировки по дням",
    HERO_WORKOUTS_KICKER: "Тренировки",
    HERO_WORKOUTS_LINE: "Выполненные и план",
    HERO_STATS_KICKER: "Статистика",
    HERO_STATS_LINE: "За текущий месяц",
    HERO_PROFILE_KICKER: "Профиль",
    HERO_PROFILE_LINE: "Настройки и стрик",
    HERO_EXERCISES_KICKER: "Каталог",
    HERO_EXERCISES_LINE: "Упражнения",
    HERO_TEMPLATES_KICKER: "Шаблоны",
    HERO_TEMPLATES_LINE: "Готовые тренировки",
    HERO_WEIGHT_KICKER: "Вес",
    HERO_WEIGHT_LINE: "История веса",
    HERO_ADMIN_KICKER: "Админ",
    HERO_ADMIN_LINE: "Пользователи",
    HERO_ACTIVE_KICKER: "Тренировка",
    HERO_DETAIL_KICKER: "Тренировка",
    TYPE_STRENGTH: "Силовое",
    TYPE_TIMED: "На время",
    TYPE_DISTANCE: "Дистанция",
    TYPE_SESSION: "Игра / сессия",
    TYPE_STRENGTH_SUB: "Подходы, повторы, вес",
    TYPE_TIMED_SUB: "Только длительность",
    TYPE_DISTANCE_SUB: "Дистанция в метрах и время",
    TYPE_SESSION_SUB: "Длительность, интенсивность 1–10, раунды",
    TYPE_SECTION: "Тип — какие поля в тренировке",
    TYPE_LOCKED: "Тип нельзя изменить: по упражнению есть записи. Создайте новое упражнение",
    ICON: "Значок",
    CREATE_CUSTOM_ACTIVITY: "Создать свой вид",
    UNIT_HOURS: "ч",
    UNIT_METERS: "м",
    UNIT_KM: "км",
    BY_TYPE: "По типам",
    DURATION_HM_HINT: "мин или ч:мм",
    TIME: "Время",
    TIME_MS_HINT: "мин:сек",
    DISTANCE_M: "Дистанция (м)",
    INTENSITY: "Интенсивность",
    INTENSITY_OF: "{n} из 10",
    ROUNDS: "Раунды",
    ERR_DURATION_REQUIRED: "Укажите длительность",
    ERR_DISTANCE_REQUIRED: "Укажите дистанцию",
    ERR_FORMAT_HM: "Неверный формат. Пример: 1:30 = 1 ч 30 мин",
    ERR_FORMAT_MS: "Неверный формат. Пример: 1:30 = 1 мин 30 сек",
    ERR_FORMAT_DISTANCE: "Только целые метры. Пример: 1500",
    ERR_SECONDS_MAX: "Секунд не больше 59. 1:30 = 1 мин 30 сек",
    ERR_VALUE_RANGE: "Слишком большое значение",
    FIELDS_INVALID: "Проверьте отмеченные поля",
    ERROR_ONE: "ошибка",
    ERROR_FEW: "ошибки",
    ERROR_MANY: "ошибок",
    ACTIVE_NEED_VALUES: "Заполните длительность или дистанцию",
    ACTIVE_DONE: "Выполнено",
    MORE_COUNT: "ещё {n}",
    HERO_EDITOR_KICKER: "Редактор",
    FIND_EXERCISE: "Найти упражнение",
    CREATE_NAMED: "Создать «{v}»",
    CHANGE: "Сменить",
    SET_N: "Подход {n}",
    DUPLICATE_SET: "Копировать подход",
    REMOVE_SET: "Удалить подход",
    DISCARD_EDITS_CONFIRM: "Закрыть без сохранения изменений?",
    ADD_SHORT: "Добавить",
    DELETE_EXERCISE: "Удалить упражнение",
    REPS_UNIT: "повт.",
  },
  en: {
    APP_NAME: "Alex Tracker",
    WELCOME_MESSAGE: "Track and plan your workouts",
    LOGIN_VIA_TELEGRAM: "Sign in with Telegram",
    LOGIN_HINT: "Open in Telegram Mini App or sign in with the widget",
    LOADING: "Loading…",
    PROFILE: "Profile",
    CALENDAR: "Calendar",
    WORKOUTS: "Workouts",
    TEMPLATES: "Templates",
    STATS: "Stats",
    STREAK: "Streak",
    WEEKS: "wks",
    WEEKLY_GOAL: "Weekly goal",
    SET_GOAL: "Set goal",
    TARGET_WORKOUTS: "Workouts per week",
    TARGET_MINUTES: "Minutes per week",
    WEEKLY_MINUTES: "Minutes this week",
    MINUTES_UNTIMED_NOT_COUNTED: "Workouts without time aren't counted",
    GOAL_MINUTES_RANGE: "1 to 6000 min",
    GOAL_COUNT_RANGE: "1 to 14",
    GOAL_NEED_ONE: "Set at least one goal",
    PROGRESS: "Progress",
    SAVE: "Save",
    CANCEL: "Cancel",
    DELETE: "Delete",
    EDIT: "Edit",
    CREATE: "Create",
    ADD_EXERCISE: "Add exercise",
    EXERCISE: "Exercise",
    EXERCISES: "Exercises",
    SETS: "Sets",
    REPS: "Reps",
    WEIGHT: "Weight",
    KG: "kg",
    NOTES: "Notes",
    TITLE: "Title",
    DATE: "Date",
    COMPLETED: "Completed",
    PLANNED: "Planned",
    MISSED: "Missed",
    MISSED_HINT:
      "The day passed, but you can still mark it done — no pressure.",
    START_TIME: "Start time",
    START_TIME_HINT:
      "Optional. With a time we remind you ahead. Without — a morning reminder on the day.",
    REMINDER_LEAD: "Remind before start",
    REMINDER_LEAD_HINT:
      "For timed plans. Date-only plans still get the morning reminder.",
    REMINDER_LEAD_1H: "1 hour",
    REMINDER_LEAD_2H: "2 hours",
    LOG_WORKOUT: "Log workout",
    PLAN_WORKOUT: "Plan workout",
    MARK_DONE: "Mark completed",
    APPLY_TEMPLATE: "Apply template",
    NO_TEMPLATES: "No templates yet",
    CREATE_TEMPLATE: "Create template",
    PREVIOUS_RESULTS: "Previous results",
    NO_HISTORY: "No previous results",
    LAST_TIME: "Last time: {v}",
    RECORDS: "Records",
    NEW_RECORD: "New record",
    REC_MAX_WEIGHT: "max weight",
    REC_EST_1RM: "est. 1RM",
    REC_MAX_DURATION: "longest time",
    REC_MAX_DISTANCE: "longest distance",
    MONTH_WORKOUTS: "Workouts this month",
    TOTAL_TONNAGE: "Monthly tonnage",
    TOP_EXERCISES: "Top exercises",
    NO_DATA: "No data yet",
    LANGUAGE: "Language",
    LOGOUT: "Log out",
    TODAY: "Today",
    MON: "Mon",
    TUE: "Tue",
    WED: "Wed",
    THU: "Thu",
    FRI: "Fri",
    SAT: "Sat",
    SUN: "Sun",
    ERROR_GENERIC: "Something went wrong",
    AUTH_FAILED: "Sign-in failed",
    CONFIRM_DELETE: "Delete?",
    EMPTY_DAY: "No workouts on this day",
    NEW_COMPLETED: "New workout",
    NEW_PLANNED: "New plan",
    FROM_TEMPLATE: "From template",
    OF: "of",
    DONE: "Done",
    BACK: "Back",
    NAME: "Name",
    USERNAME: "Username",
    OPTIONAL: "optional",
    CATALOG: "Catalog",
    MUSCLE_GROUPS: "Muscle groups",
    FILTER_ALL: "All",
    SEARCH: "Search",
    FROM_CATALOG: "From catalog",
    NO_CATALOG_EXERCISES: "No exercises in catalog yet",
    ADD_TO_CATALOG: "Add to catalog",
    NEW_EXERCISE: "New exercise",
    EDIT_EXERCISE: "Edit exercise",
    PICK_EXERCISE: "Pick exercise",
    MG_CHEST: "Chest",
    MG_BACK: "Back",
    MG_SHOULDERS: "Shoulders",
    MG_BICEPS: "Biceps",
    MG_TRICEPS: "Triceps",
    MG_LEGS: "Legs",
    MG_GLUTES: "Glutes",
    MG_CORE: "Core",
    MG_CARDIO: "Cardio",
    MG_FULL_BODY: "Full body",
    MG_OTHER: "Other",
    DURATION: "Duration",
    DURATION_MIN: "min",
    TOTAL_DURATION: "Time this month",
    AVG_DURATION: "Avg workout",
    START_WORKOUT_TIMER: "Start workout",
    STOP_WORKOUT_TIMER: "Finish workout",
    TIMER_RUNNING: "Workout in progress",
    CLEAR: "Clear",
    REPEAT: "Repeat",
    REPEAT_LAST: "Repeat last",
    REPEAT_LAST_WEEK: "Week → plan",
    REPEAT_WORKOUT: "Repeat workout",
    REPEAT_FROM: "Based on",
    REPEAT_HINT: "Edit and save — date, notes and duration are not copied",
    REPEAT_CHOOSE: "How do you want to repeat this workout?",
    REPEAT_AS_COMPLETED: "As completed",
    REPEAT_AS_PLANNED: "As planned",
    SAVE_AS_COMPLETED: "Completed",
    SAVE_AS_PLANNED: "Planned",
    COPY_NOTES: "Copy notes",
    COPY_EXERCISE_NOTES_HINT: "including exercise notes",
    NO_WORKOUT_TO_REPEAT: "No completed workouts to repeat",
    NO_LAST_WEEK_WORKOUTS: "No completed workouts last week",
    CONFIRM_REPEAT_LAST_WEEK:
      "Create {n} planned workout(s) this week from last week?",
    EXERCISE_NOTES_PLACEHOLDER: "Exercise note (optional)",
    SHOW_MORE: "more",
    SHOW_LESS: "less",
    WORKOUT_NOT_FOUND: "Workout not found",
    WORKOUT_NOT_FOUND_HINT:
      "It may have been deleted or the link is outdated.",
    BACK_TO_WORKOUTS: "Back to workouts",
    WORKOUTS_LIST: "List",
    CALENDAR_LIST_HINT: "Browse every workout in one list",
    ALL_WORKOUTS: "All workouts",
    ALL_WORKOUTS_HINT: "Completed and planned in one place",
    NO_WORKOUTS_YET: "No workouts yet",
    NO_COMPLETED_WORKOUTS: "No completed workouts yet",
    NO_PLANNED_WORKOUTS: "No planned workouts yet",
    NO_WORKOUTS_FOR_DAY: "No workouts on this day",
    WORKOUTS_EMPTY_HINT: "Log a session or schedule one ahead",
    BACK_TO_CALENDAR: "Back to calendar",
    CLEAR_FILTER: "Clear",
    DAY_WORKOUTS: "This day",
    VIEW_DAY_LIST: "Full day",
    BODY_WEIGHT: "Weight",
    CURRENT_WEIGHT: "Current weight",
    LOG_WEIGHT: "Log weight",
    EDIT_WEIGHT: "Edit entry",
    WEIGHT_CHART: "Trend",
    WEIGHT_HISTORY: "History",
    NO_WEIGHT_DATA: "No weight entries yet",
    VS_PREVIOUS: "vs prev",
    DELTA_7D: "7 days",
    DELTA_30D: "30 days",
    PERIOD_30D: "1 mo",
    PERIOD_90D: "3 mo",
    PERIOD_ALL: "All",
    PROGRESS_RANGE_1Y: "Year",
    PROGRESS_NEED_TWO: "At least two entries needed",
    PROGRESS_CHART: "Progress chart",
    WEIGHT_MIN: "Min",
    WEIGHT_MAX: "Max",
    WEIGHT_AVG: "Avg",
    WEIGHT_INVALID: "Enter a valid weight",
    WEIGHT_NOTES_HINT: "morning / after workout…",
    OPEN_WEIGHT: "Open weight log",
    ADMIN_PANEL: "Admin",
    ADMIN_HINT: "Internal panel. Visible to admins only.",
    ADMIN_OVERVIEW: "Platform overview",
    ADMIN_USERS: "Users",
    ADMIN_ADMINS: "Admins",
    ADMIN_COMPLETED: "Completed",
    ADMIN_PLANNED: "Planned",
    ADMIN_OPEN_PLANS: "open",
    ADMIN_WEIGHT_LOGS: "entries",
    ADMIN_NEW_USERS_30D: "New (30d)",
    ADMIN_SEARCH_USERS: "Search: name, @username, telegram id",
    ADMIN_FILTER_ADMINS: "Admins",
    ADMIN_FILTER_USERS: "Users",
    ADMIN_LAST_WORKOUT: "Last workout",
    ADMIN_USER_DETAIL: "User",
    ADMIN_JOINED: "Joined",
    ADMIN_GRANT: "Grant admin",
    ADMIN_REVOKE: "Revoke admin",
    ADMIN_GRANT_CONFIRM: "Grant admin privileges?",
    ADMIN_REVOKE_CONFIRM: "Revoke admin privileges?",
    ADMIN_CANNOT_SELF: "You cannot remove your own admin rights",
    ADMIN_RECENT_COMPLETED: "Recent completed",
    ADMIN_RECENT_PLANNED: "Recent planned",
    CLOSE: "Close",
    COMPLETE_WORKOUT_TITLE: "Mark workout done?",
    COMPLETE_WORKOUT_HINT:
      "You can set duration now or leave it empty and edit later.",
    COMPLETE_AND_OPEN: "Save and open",
    COMPLETE_SKIP_DURATION: "Skip duration — open",
    CREATE_WORKOUT: "Create workout",
    START_WORKOUT_NOW: "Start now",
    START_WORKOUT_NOW_HINT: "Jump into a live session",
    LOG_COMPLETED_SHORT: "Log completed",
    LOG_COMPLETED_HINT: "Add an already finished workout",
    PLAN_WORKOUT_SHORT: "Schedule",
    PLAN_WORKOUT_HINT: "Plan for a chosen date",
    FROM_TEMPLATE_SHORT: "From template",
    FROM_TEMPLATE_HINT: "Build from an existing template",
    ACTIVE_WORKOUT: "Active workout",
    FINISH_WORKOUT: "Finish workout",
    ACTIVE_DISCARD: "Exit",
    ACTIVE_DISCARD_CONFIRM:
      "Exit without saving? Your workout progress will be lost.",
    ACTIVE_REPLACE_CONFIRM:
      "You already have an unfinished workout. Replace it?",
    ACTIVE_NEED_EXERCISE: "Add at least one exercise with sets",
    ACTIVE_SAVED: "Workout saved",
    ACTIVE_EMPTY: "Add an exercise to get started",
    ACTIVE_RESUME: "Resume workout",
    EXERCISE_LIST: "List",
    NEXT_EXERCISE: "Next",
    NEXT: "Next",
    PREV: "Back",
    GO_TO_EXERCISE: "Go to exercise",
    FINISH_SHORT: "Done",
    CIRCUIT: "Circuit",
    CIRCUIT_ROUND: "Round {n} of {total}",
    CIRCUIT_ROUND_SHORT: "{n}/{total}",
    CIRCUIT_ROUNDS: "{n} rounds",
    CIRCUIT_ROUNDS_LABEL: "rounds",
    CIRCUIT_BANKED: "in rounds",
    CIRCUIT_IN: "In circuit",
    CIRCUIT_JOIN: "To circuit",
    CIRCUIT_LEAVE: "Remove",
    CIRCUIT_LINK_PREV: "With previous",
    CIRCUIT_GROUP_TITLE: "Circuit",
    CIRCUIT_GROUP_COUNT: "{n} ex.",
    CIRCUIT_HINT:
      "A circuit repeats exercises as rounds. Tap “To circuit” or “With previous”.",
    CIRCUIT_BADGE: "circuit",
    TOGGLE_CIRCUIT: "In circuit / leave circuit",
    LINK_CIRCUIT: "Link with previous into circuit",
    ADD_SET: "Set",
    SET_DONE: "Mark set done",
    REST_TIMER: "Rest",
    REST_START: "Start",
    REST_START_SHORT: "Rest",
    REST_PAUSE: "Pause",
    REST_RESUME: "Resume",
    REST_RESET: "Reset",
    REST_CUSTOM: "Custom",
    REST_AGAIN: "Again",
    REST_DONE: "Rest done",
    REST_PAUSED: "Paused",
    REST_RUNNING: "Running",
    REST_HINT: "Mark a set ✓ to auto-start rest, or pick a duration below.",
    REST_PICK_DURATION: "Rest duration",
    WORKOUT_PAUSE: "Pause workout",
    WORKOUT_RESUME: "Resume",
    WORKOUT_PAUSED: "paused",
    WORKOUT_PAUSED_HINT:
      "Workout paused — the clock is frozen. Edit sets freely, then resume.",
    CATALOG_LOOKUP_HINT: "Catalog · start typing a name",
    NEW_EXERCISE_AUTO_HINT: "New — will be added to catalog",
    UNIT: "Unit",
    UNIT_KG: "kg",
    UNIT_REPS: "reps",
    UNIT_SECONDS: "sec",
    UNIT_MINUTES: "min",
    DRAG_REORDER: "Drag to reorder exercise",
    STREAK_UPDATED: "Streak updated",
    STREAK_UPDATED_HINT: "Another week in a row",
    STREAK_WEEKS_COUNT: "{n} weeks in a row",
    STREAK_DELTA: "+{n}",
    STREAK_CONTINUE: "Continue",
    STREAK_SESSION_DONE: "Workout complete",
    STREAK_FIRST: "First workout",
    STREAK_BACK: "Streak is back",
    STREAK_TIER_SPARK: "1 wk",
    STREAK_TIER_EMBER: "3 wks",
    STREAK_TIER_FLAME: "5 wks",
    STREAK_TIER_INFERNO: "10 wks",
    STREAK_TIER_MYTHIC: "15 wks",
    STREAK_TIER_LEGEND: "20 wks",
    STREAK_TIER_IMMORTAL: "30 wks",
    HERO_LOGIN_KICKER: "Sign in",
    HERO_LOGIN_TITLE: "Sign in",
    HERO_LOGIN_LINE: "Track and plan your workouts",
    HERO_CALENDAR_KICKER: "Calendar",
    HERO_CALENDAR_LINE: "Workouts by day",
    HERO_WORKOUTS_KICKER: "Workouts",
    HERO_WORKOUTS_LINE: "Completed and planned",
    HERO_STATS_KICKER: "Stats",
    HERO_STATS_LINE: "This month",
    HERO_PROFILE_KICKER: "Profile",
    HERO_PROFILE_LINE: "Settings and streak",
    HERO_EXERCISES_KICKER: "Catalog",
    HERO_EXERCISES_LINE: "Exercises",
    HERO_TEMPLATES_KICKER: "Templates",
    HERO_TEMPLATES_LINE: "Saved workouts",
    HERO_WEIGHT_KICKER: "Weight",
    HERO_WEIGHT_LINE: "Weight history",
    HERO_ADMIN_KICKER: "Admin",
    HERO_ADMIN_LINE: "Users",
    HERO_ACTIVE_KICKER: "Workout",
    HERO_DETAIL_KICKER: "Workout",
    TYPE_STRENGTH: "Strength",
    TYPE_TIMED: "Timed",
    TYPE_DISTANCE: "Distance",
    TYPE_SESSION: "Game / session",
    TYPE_STRENGTH_SUB: "Sets, reps, weight",
    TYPE_TIMED_SUB: "Duration only",
    TYPE_DISTANCE_SUB: "Distance in meters and time",
    TYPE_SESSION_SUB: "Duration, intensity 1–10, rounds",
    TYPE_SECTION: "Type — which fields a workout shows",
    TYPE_LOCKED: "The type can't be changed: this exercise has records. Create a new exercise",
    ICON: "Icon",
    CREATE_CUSTOM_ACTIVITY: "Create custom activity",
    UNIT_HOURS: "h",
    UNIT_METERS: "m",
    UNIT_KM: "km",
    BY_TYPE: "By type",
    DURATION_HM_HINT: "min or h:mm",
    TIME: "Time",
    TIME_MS_HINT: "min:sec",
    DISTANCE_M: "Distance (m)",
    INTENSITY: "Intensity",
    INTENSITY_OF: "{n} of 10",
    ROUNDS: "Rounds",
    ERR_DURATION_REQUIRED: "Enter a duration",
    ERR_DISTANCE_REQUIRED: "Enter a distance",
    ERR_FORMAT_HM: "Invalid format. Example: 1:30 = 1 h 30 min",
    ERR_FORMAT_MS: "Invalid format. Example: 1:30 = 1 min 30 sec",
    ERR_FORMAT_DISTANCE: "Whole meters only. Example: 1500",
    ERR_SECONDS_MAX: "Seconds must be 59 or less. 1:30 = 1 min 30 sec",
    ERR_VALUE_RANGE: "Value is too large",
    FIELDS_INVALID: "Check the marked fields",
    ERROR_ONE: "error",
    ERROR_FEW: "errors",
    ERROR_MANY: "errors",
    ACTIVE_NEED_VALUES: "Fill in the duration or distance",
    ACTIVE_DONE: "Done",
    MORE_COUNT: "{n} more",
    HERO_EDITOR_KICKER: "Editor",
    FIND_EXERCISE: "Find exercise",
    CREATE_NAMED: "Create “{v}”",
    CHANGE: "Change",
    SET_N: "Set {n}",
    DUPLICATE_SET: "Duplicate set",
    REMOVE_SET: "Remove set",
    DISCARD_EDITS_CONFIRM: "Discard unsaved changes?",
    ADD_SHORT: "Add",
    DELETE_EXERCISE: "Delete exercise",
    REPS_UNIT: "reps",
  },
} as const;

export type MessageKey = keyof typeof dictionaries.ru;

const [locale, setLocale] = createSignal<Locale>("ru");

export function getLocale() {
  return locale();
}

export function setAppLocale(lang: Locale) {
  setLocale(lang);
  try {
    localStorage.setItem("locale", lang);
  } catch {
    /* ignore */
  }
}

export function initLocale(preferred?: string) {
  const stored = (() => {
    try {
      return localStorage.getItem("locale");
    } catch {
      return null;
    }
  })();
  const lang = (stored || preferred || "ru").startsWith("en") ? "en" : "ru";
  setLocale(lang);
}

export function t(key: MessageKey): string {
  const lang = locale();
  return dictionaries[lang][key] ?? dictionaries.ru[key] ?? key;
}

export { locale };
